import React from "react";
import { Box } from "@mui/material";
import colors from "../../themes/colors";
import { dt } from "../../themes/redesignTokens";

const standardStyles = {
  className: "text-12-regular",
  color: colors.secondary.gray20,
  background: "none",
  boxShadow: `0px 0px 0px 0.8px ${colors.secondary.gray20} inset`
};

const moreStyles = {
  className: "text-12-medium",
  color: dt.blue,
  background: colors.secondary.gray96,
  boxShadow: "none"
}

export interface ChipProps {
  value: string;
  variant?: "default" | "more"
}

const Chip = ({ value, variant = "default" }: ChipProps) => {
  const styles = variant === "more" ? moreStyles : standardStyles;

  return (
    <Box
      className={styles.className}
      color={styles.color}
      sx={{
        background: styles.background,
        boxShadow: styles.boxShadow,
        borderRadius: "16px",
        width: "fit-content",
        padding: "2px 8px"
      }}
    >
      {value}
    </Box>
  );
};

export default Chip;